import AXIOS from "@/axios";

import { APIResponse } from "@/types";
import {
  SubmissionModel,
  SubmissionQuery,
  DownloadSubmissionQuery,
  SubmissionFormData,
} from "@/types/submission.model";

import { removeEmptyProps } from "@/utils/constants";
import { buildAssignmentRecordApiParams } from "@/utils/assignmentRecordParams";
import moment from "moment";

function withSubmissionRecordParams(
  query: SubmissionQuery | DownloadSubmissionQuery
): Record<string, unknown> {
  const { recordType, gradeId, classId, ...rest } = query;

  return removeEmptyProps({
    ...rest,
    ...buildAssignmentRecordApiParams({ recordType, gradeId, classId }),
  });
}

export const getAllSubmissionsService = async (query: SubmissionQuery) => {
  if (query.fromDate && query.toDate) {
    query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    query.toDate = moment(new Date(query.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<APIResponse<SubmissionModel[]>>("/asgmt/api/v1/subsn/list", {
    params: withSubmissionRecordParams(query),
  });
};

export const addNewSubmissionService = async (data: SubmissionFormData) => {
  return AXIOS.post<APIResponse<SubmissionModel>>(
    "/asgmt/api/v1/subsn/add",
    data
  );
};

export const downloadSubmissionService = async (
  type: "pdf" | "xl" | "csv",
  params: DownloadSubmissionQuery
) => {
  if (params.fromDate && params.toDate) {
    params.fromDate = moment(new Date(params.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    params.toDate = moment(new Date(params.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<{ message: string }>(`/asgmt/api/v1/subsn/dwnld/${type}`, {
    params: withSubmissionRecordParams(params),
    responseType: "blob",
  });
};

export const updateSubmissionStatusService = async ({
  assignmentId,
  queryId,
}: {
  assignmentId?: string;
  queryId?: string;
}) => {
  let params: any = {};

  if (assignmentId) {
    params["assignId"] = assignmentId;
  }

  if (queryId) {
    params["queryId"] = queryId;
  }

  return AXIOS.get<APIResponse<SubmissionModel>>(
    `/asgmt/api/v1/status/update`,
    {
      params: removeEmptyProps(params),
    }
  );
};
